import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";
export const walletShowChangeSubsState = atom({
  key: 'walletShowChangeSubsState',
  default: false,
  effects: []
});
